import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Clock, CheckCircle, BarChart3, Headphones, Zap } from 'lucide-react';

const ProvenResults = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto bg-gradient-to-br from-[#5E4BD2] to-[#7662DA] rounded-2xl overflow-hidden shadow-xl">
          <div className="p-8 md:p-12 text-center">
            <div className="inline-block bg-white/20 text-white text-xs font-medium px-3 py-1 rounded-full backdrop-blur-sm mb-6">
              PROVEN RESULTS
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
              Slash Your Screening Time by 70%
            </h2>
            <p className="text-white/90 text-lg max-w-2xl mx-auto mb-8">
              Join 1000+ recruiters who are saving time, reducing costs and making better hires with RoundOne AI
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10 max-w-4xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-left">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/20 text-white mb-4">
                  <Clock className="h-6 w-6" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">Save 15+ Hours/Week</h3>
                <p className="text-white/80">Automate initial phone screenings and cut your admin time by 70%</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-left">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/20 text-white mb-4">
                  <CheckCircle className="h-6 w-6" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">Better Quality Hires</h3>
                <p className="text-white/80">Consistent, data-driven evaluations lead to more successful placements</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-left">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/20 text-white mb-4">
                  <BarChart3 className="h-6 w-6" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">60% Cost Reduction</h3>
                <p className="text-white/80">Cut screening costs and redirect resources to closing top candidates</p>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row justify-center gap-4 max-w-xl mx-auto">
              <Link to="/request-demo" className="w-full sm:w-auto">
                <Button 
                  className="bg-white text-roundone-dark-purple py-6 px-8 text-lg rounded-full transition-all duration-300 hover:bg-white/90 hover:shadow-lg hover:scale-105 w-full sm:w-auto flex items-center justify-center" 
                >
                  Book a Demo
                  <Headphones className="ml-2 h-5 w-5" />
                </Button>
              </Link>
              <Link to="/sign-in?tab=register" className="w-full sm:w-auto">
                <Button 
                  className="gradient-button py-6 px-8 text-lg rounded-full transition-all duration-300 hover:shadow-lg hover:scale-105 w-full sm:w-auto flex items-center justify-center" 
                >
                  Get started for free
                  <Zap className="ml-2 h-5 w-5 animate-pulse" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProvenResults; 